<template>
    <div class="ngdialog__button-group">
        <div class="ngdialog__button-group__item">
            <a class="ngdialog__button ngdialog__button--secondary" @click="$parent.$emit('close')">
                <span class="ngdialog__button__text">{{ $t('buttons.cancel') }}</span>
            </a>
        </div>

        <div class="ngdialog__button-group__item">
            <button
                type="submit"
                class="ngdialog__button ngdialog__button--primary"
                :disabled="disabled"
                :class="{ 'ngdialog__button--disabled': disabled }"
            >
                <span class="ngdialog__button__text">{{ submitText }}</span>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'dialog-buttons',
    props: {
        submitText: {
            type: String,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
